import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NewCertificationService} from "./services/new-certification.service";
import {AssociationService} from "../associactions/services/association.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-new-certification-objective-edit',
    templateUrl: './new-certification-objective-edit.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationObjectiveEditComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    associations: any[] = [];
    certDomains: any[] = [];
    certification: any = null;

    htmlOutput = '';
    textOutput = '';
    showOutput = false;

    domainId: any = null;
    objectiveId: any = null;
    domain: any = null;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private certificationService: NewCertificationService,
        private associationService: AssociationService
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            certificationTitle: [null, [Validators.required]],
            providerId: [null, [Validators.required]],
            domains: this.formBuilder.array([]),
        });

        this.addDomain();
    }

    get domains(): FormArray {
        return this.form.get('domains') as FormArray;
    }

    objectives(domainIndex: number): FormArray {
        return this.domains.at(domainIndex).get('objectives') as FormArray;
    }

    addDomain() {
        const domainFG = this.formBuilder.group({
            id: [null, [Validators.required]],
            domainName: [null, [Validators.required]],
            objectives: this.formBuilder.array([]),
            removedObjectives: this.formBuilder.array([]),
            newObjectives: this.formBuilder.array([])
        })
        this.domains.push(domainFG);
    }

    addObjective(domainIndex: number) {
        const objectiveFG = this.formBuilder.group({
            id: [null, []],
            objectiveName: [null, [Validators.required]],
            term: [null, [Validators.required]],
        });

        this.objectives(domainIndex).push(objectiveFG);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.associations = await this.associationService.getAllNoPaging();
        this.certification = await this.certificationService.getById(this.activatedRoute.snapshot.params.certificationId);
        this.certDomains = await this.certificationService.getDomainsByCertificationId(this.certification.id);
        this.domainId = this.activatedRoute.snapshot.params.domainId;
        this.objectiveId = this.activatedRoute.snapshot.params.objectiveId;

        this.form.controls.certificationTitle.setValue(this.certification.certificationTitle);
        this.form.controls.providerId.setValue(this.certification.association.id);

        this.form.controls.certificationTitle.disable();
        this.form.controls.providerId.disable();

        const domains = this.certDomains as any[];
        if(domains) {
            this.domain = domains.find(d => d.id == this.domainId);

            this.domains.at(0).get('domainName').setValue(this.domain.domainName);
            this.domains.at(0).get('domainName').disable();
            this.domains.at(0).get('id').setValue(this.domain.id);

            let i = 0;

            this.domain.objectives.forEach((r: { id:any; objectiveName: any; term: any }) => {
                if(r.id == this.objectiveId) {
                    this.addObjective(0);
                    this.objectives(0).at(i).get('id').setValue(r.id);
                    this.objectives(0).at(i).get('objectiveName').setValue(r.objectiveName);
                    this.objectives(0).at(i).get('term').setValue(r.term);
                    i++;
                }

            });

        }

    }

    saveDomain() {
        const validation = this.check(this.form);
        if (validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Add New Certification Domain",
                subMessage: "Are you sure want to add new certification domain?",
                buttonOkLabel: 'Yes, Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {

                let payload = this.form.value;
                payload['id'] = this.certification.id;
                payload['certificationTitle'] = this.certification.certificationTitle;
                payload['providerId'] = this.certification.association.id;

                this.certificationService.updateCertificationDomainObjective(this.form.value, this.certification.id, this.domain.id, this.objectiveId).then(r => {
                    this.showSnackbarDark('Certification Domain', 'Certification domain has been added successfully', '');
                    this.router.navigate([`/office/new-certification/detail/${this.certification.id}`], {queryParams: {tab: 'objectives'}}).then();
                })
            }
        })
    }

}
